// extracted by mini-css-extract-plugin
export var callCard = "_kw-0";
export var callMessageButton = "_kw-1";
export var helpIcon = "_kw-3";
export var helpIconContainer = "_kw-4";
export var verticalDivider = "_kw-2";